import { __assign, __read, __rest, __spreadArray, __awaiter, __generator } from 'tslib';
import React, { memo, useRef, useState, useCallback, useEffect, useMemo } from 'react';
import { useBoolean, preventBodyScroll, usePrevious } from '@sravni/react-utils';
import ReactDOM from 'react-dom';
import crypto from 'crypto';
import _isEqual from 'lodash/isEqual';
import { Skeleton } from '@sravni/react-design-system/lib/Skeleton';

var OutOfPageTypes;
(function (OutOfPageTypes) {
    OutOfPageTypes["FULLSCREEN"] = "FullScreen";
    OutOfPageTypes["MOBILE_BOTTOM"] = "MobileBottom";
})(OutOfPageTypes || (OutOfPageTypes = {}));
var BannerFromIframeToBannerType = {
    showFullscreen: OutOfPageTypes.FULLSCREEN,
    fullSreenBannerHTML5: OutOfPageTypes.FULLSCREEN,
    mobileBanner: OutOfPageTypes.MOBILE_BOTTOM
};
var BANNER_TYPES;
(function (BANNER_TYPES) {
    BANNER_TYPES["TOP"] = "top";
    BANNER_TYPES["SIDE"] = "side";
    BANNER_TYPES["TGBM_7"] = "tgbm7";
    BANNER_TYPES["OUT_OF_PAGE"] = "outOfPage";
    BANNER_TYPES["TGB_BOTTOM"] = "tgbBottom";
})(BANNER_TYPES || (BANNER_TYPES = {}));

var AD_FOX_DICTIONARY = {
    order: 'puid1',
    alias: 'puid2',
    pid: 'puid3',
    ip: 'puid4',
    bi: 'puid5',
    pm: 'puid6',
    serveys: 'puid7',
    vs: 'puid8',
    sravniaffid: 'puid9',
    bic: 'puid10',
    teg: 'puid11',
    rubrika: 'puid12',
    page_type: 'puid13',
    subStatus: 'puid14',
    auth: 'puid15',
    // 16???
    utmcsr: 'puid17',
    utmcmd: 'puid18',
    ab_test: 'puid19',
    organizationType: 'puid20'
};
var YANDEX = 'yandex';
var COMPANY_ID_YANDEX = 302581;

var classnames = {exports: {}};

/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/

(function (module) {
/* global define */

(function () {

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue (arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if (typeof arg !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass (value, newClass) {
		if (!newClass) {
			return value;
		}
	
		if (value) {
			return value + ' ' + newClass;
		}
	
		return value + newClass;
	}

	if (module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else {
		window.classNames = classNames;
	}
}());
}(classnames));

var cn = classnames.exports;

/**
 * Return plural noun form
 * @param {number} n
 * @param {string} one
 * @param {string} few
 * @param {string} many
 * @returns string
 * @example
 * ```ts
 * pluralize(6, 'яблоко', 'яблока', 'яблок') -> яблок
 * ```
 */
const pluralize = (n, one, few, many) => {
    const nP100 = n % 100;
    const nP10 = n % 10;
    if (nP10 === 1 && nP100 !== 11) {
        return one;
    }
    if (nP10 >= 2 && nP10 <= 4 && (nP100 < 10 || nP100 >= 20)) {
        return few;
    }
    return many;
};

var Cross = function () { return (React.createElement("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("g", { clipPath: "url(#clip0)" },
        React.createElement("path", { d: "M10 9.99998L5.05029 14.9497M5.05029 5.05023L10 9.99998L5.05029 5.05023ZM10 9.99998L14.9497 14.9497L10 9.99998ZM10 9.99998L14.9497 5.05023L10 9.99998Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
        React.createElement("path", { d: "M79 -22H-51C-53.7614 -22 -56 -19.7614 -56 -17V37C-56 39.7614 -53.7614 42 -51 42H79C81.7614 42 84 39.7614 84 37V-17C84 -19.7614 81.7614 -22 79 -22Z", stroke: "currentColor", strokeDasharray: "10 5" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "clip0" },
            React.createElement("rect", { width: "20", height: "20", fill: "white" }))))); };

var modules_7e6c94c2 = {"pixel-img":"_xtswor","pixels":"_us3due"};
/*SRAVNI__src/src/components/Pixel/pixel.module.scss__SRAVNI*/;

var Pixel$1 = memo(function (_a) {
    var pixels = _a.pixels;
    if (!pixels)
        return null;
    var links = pixels.split(',');
    if (!(links === null || links === void 0 ? void 0 : links.length))
        return null;
    return (React.createElement("div", { className: modules_7e6c94c2.pixels }, links.map(function (url) { return (React.createElement("img", { src: url, className: modules_7e6c94c2.pixelImg, alt: "", key: "pixel-link-".concat(url) })); })));
});

var modules_3734c084 = {"wrapper":"_119hqw2","wrapper--hidden":"_1464b2t","overlay":"_j8io6p","inner-wrapper":"_1vj1c8h","header":"_ho4ezg","close-button":"_sbq3ea"};
/*SRAVNI__src/src/components/FullScreenWrapper/fullscreen-wrapper.module.scss__SRAVNI*/;

var normalizeFullscreenBanner = function (bannerFromAdfox) { return (__assign(__assign({}, bannerFromAdfox), { data: __assign(__assign({}, bannerFromAdfox.data), { scripts: bannerFromAdfox.data.content2, html: bannerFromAdfox.data.content3 }) })); };

var portalContainer = null;
var portalAttribute = 'portal-banner-container';
var FullScreenWrapper$1 = memo(function (_a) {
    var _b;
    var _c;
    var bannerInfo = _a.bannerInfo, setBannerShown = _a.setBannerShown;
    var _d = __read(useBoolean(false), 2), isContainerMounted = _d[0], setIsContainerMounted = _d[1];
    var _e = __read(useBoolean(false), 2), isBannerVisible = _e[0], setBannerVisible = _e[1];
    var firstRenderRef = useRef(true);
    var _f = __read(useState(10), 2), countdownTime = _f[0], setCountdownTime = _f[1];
    var _g = normalizeFullscreenBanner(bannerInfo), pixels = _g.pixels, _h = _g.data, width = _h.width, height = _h.height, scripts = _h.scripts, contentStyle = _h.contentStyle, html = _h.html;
    var portal = React.useMemo(function () {
        if (portalContainer) {
            return portalContainer;
        }
        var el = document.querySelector("div[".concat(portalAttribute, "]"));
        if (el) {
            portalContainer = el;
            return portalContainer;
        }
        portalContainer = document.createElement('div');
        portalContainer.setAttribute(portalAttribute, '');
        return portalContainer;
    }, []);
    var handleCloseModal = useCallback(function () {
        setBannerVisible.off();
    }, [setBannerVisible]);
    useEffect(function () {
        var _a, _b;
        if (!firstRenderRef.current)
            return;
        setBannerShown();
        setBannerVisible.on();
        setCountdownTime((_b = Number((_a = bannerInfo === null || bannerInfo === void 0 ? void 0 : bannerInfo.data) === null || _a === void 0 ? void 0 : _a.timer)) !== null && _b !== void 0 ? _b : 10);
        firstRenderRef.current = false;
    }, [(_c = bannerInfo === null || bannerInfo === void 0 ? void 0 : bannerInfo.data) === null || _c === void 0 ? void 0 : _c.timer, setBannerShown, setBannerVisible]);
    useEffect(function () {
        if (!isBannerVisible)
            return;
        var counterId = setInterval(function () {
            if (countdownTime > 0) {
                setCountdownTime(countdownTime - 1);
            }
            else if (countdownTime === 0) {
                handleCloseModal();
            }
        }, 1000);
        return function () {
            clearInterval(counterId);
        };
    }, [countdownTime, handleCloseModal, isBannerVisible]);
    useEffect(function () {
        if (!portal || isContainerMounted)
            return;
        document.body.appendChild(portal);
        setIsContainerMounted.on();
    }, [isContainerMounted, portal, setIsContainerMounted]);
    useEffect(function () {
        if (isBannerVisible) {
            preventBodyScroll(true);
        }
        else {
            preventBodyScroll(false);
        }
        return function () { return preventBodyScroll(); };
    }, [isBannerVisible]);
    var banner = (React.createElement("div", { className: cn(modules_3734c084.wrapper, (_b = {}, _b[modules_3734c084['wrapper--hidden']] = !isBannerVisible, _b)) },
        React.createElement("div", { className: modules_3734c084.overlay, onClick: handleCloseModal }),
        React.createElement("div", { className: modules_3734c084.innerWrapper },
            React.createElement(Pixel$1, { pixels: isBannerVisible ? pixels === null || pixels === void 0 ? void 0 : pixels.onShow : pixels === null || pixels === void 0 ? void 0 : pixels.onClose }),
            React.createElement("div", { className: modules_3734c084.header },
                React.createElement("div", null,
                    "\u0411\u0430\u043D\u043D\u0435\u0440 \u0437\u0430\u043A\u0440\u043E\u0435\u0442\u0441\u044F \u0447\u0435\u0440\u0435\u0437 ",
                    countdownTime,
                    " ",
                    pluralize(countdownTime, 'секунду', 'секунды', 'секунд')),
                React.createElement("div", { className: modules_3734c084.closeButton, onClick: handleCloseModal },
                    React.createElement(Cross, null))),
            React.createElement("script", null, scripts),
            React.createElement("style", null, contentStyle),
            React.createElement("div", { style: { width: "".concat(Number(width), "px"), height: "".concat(Number(height), "px"), overflow: 'hidden' }, dangerouslySetInnerHTML: { __html: html } }))));
    if (portal && isContainerMounted) {
        return ReactDOM.createPortal(banner, portal);
    }
    return null;
});

let urlAlphabet =
  'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict';

const POOL_SIZE_MULTIPLIER = 128;
let pool, poolOffset;
let fillPool = bytes => {
  if (!pool || pool.length < bytes) {
    pool = Buffer.allocUnsafe(bytes * POOL_SIZE_MULTIPLIER);
    crypto.randomFillSync(pool);
    poolOffset = 0;
  } else if (poolOffset + bytes > pool.length) {
    crypto.randomFillSync(pool);
    poolOffset = 0;
  }
  poolOffset += bytes;
};
let nanoid = (size = 21) => {
  fillPool((size -= 0));
  let id = '';
  for (let i = poolOffset - size; i < poolOffset; i++) {
    id += urlAlphabet[pool[i] & 63];
  }
  return id
};

var generateHolder = function (_a) {
    var _b = _a.urlHolderTag, urlHolderTag = _b === void 0 ? 'a' : _b, children = _a.children, props = __rest(_a, ["urlHolderTag", "children"]);
    return React.createElement(urlHolderTag, props, children);
};
var generateAdditionalField = function (structure) {
    var tag = structure.tag, tagClassName = structure["class"], value = structure.value, children = structure.children;
    var childrenForNewElement = (React.createElement(React.Fragment, null,
        value, children === null || children === void 0 ? void 0 :
        children.map(function (child) { return generateAdditionalField(child); })));
    return React.createElement(tag, { className: tagClassName }, childrenForNewElement);
};
var MobileBottomWrapper = memo(function (_a) {
    var bannerInfo = _a.bannerInfo, setBannerShown = _a.setBannerShown, onClick = _a.onClick;
    var _b = __read(useBoolean(true), 2), isBannerVisible = _b[0], setBannerVisible = _b[1];
    var _c = __read(useBoolean(true), 2), isCloseButtonVisible = _c[0], setCloseButtonVisible = _c[1];
    var handleClickCloseButton = useCallback(function (e) {
        e === null || e === void 0 ? void 0 : e.preventDefault();
        e === null || e === void 0 ? void 0 : e.stopPropagation();
        setBannerVisible.off();
        setBannerShown();
    }, [setBannerShown, setBannerVisible]);
    var _d = bannerInfo, pixels = _d.pixels, containerClass = _d.containerClass, isNeedCloseButton = _d.needCloseBtn, styles = _d.styles, url = _d.url, urlHolderClass = _d.urlHolderClass, urlHolderTag = _d.urlHolderTag, timer = _d.timer, label = _d.label, labelClass = _d.labelClass, additionalFieldStructure = _d.additionalField;
    useEffect(function () {
        var timerId = setTimeout(function () {
            setCloseButtonVisible.on();
        }, timer !== null && timer !== void 0 ? timer : 0);
        return function () {
            clearTimeout(timerId);
        };
    }, [setCloseButtonVisible, timer]);
    var HolderElement = useMemo(function () {
        return generateHolder({
            urlHolderTag: urlHolderTag,
            children: (React.createElement(React.Fragment, null,
                isNeedCloseButton && isCloseButtonVisible && (React.createElement("div", { className: "btn-close", onClick: handleClickCloseButton })),
                label !== undefined && React.createElement("div", { className: labelClass }, label),
                additionalFieldStructure !== undefined && generateAdditionalField(additionalFieldStructure))),
            className: urlHolderClass,
            href: url,
            target: '_blank',
            rel: 'noreferrer'
        });
    }, [
        urlHolderTag,
        isNeedCloseButton,
        isCloseButtonVisible,
        handleClickCloseButton,
        labelClass,
        label,
        additionalFieldStructure,
        urlHolderClass,
        url,
    ]);
    return (React.createElement("div", { className: containerClass, "data-js": "mobileBottomBanner", onClick: onClick }, pixels === null || pixels === void 0 ? void 0 :
        pixels.map(function (pixel) { return React.createElement(Pixel$1, { pixels: pixel, key: "pixel-".concat(pixel, "-").concat(nanoid()) }); }),
        React.createElement("style", null, styles),
        isBannerVisible && HolderElement));
});

var _a$1;
var outOfPageWrappersMap = (_a$1 = {},
    _a$1[OutOfPageTypes.MOBILE_BOTTOM] = MobileBottomWrapper,
    _a$1[OutOfPageTypes.FULLSCREEN] = FullScreenWrapper$1,
    _a$1);
var useOutOfPageBanner = function (isOutOfPage, className) {
    var _a = __read(useBoolean(false), 2), isBannerShown = _a[0], setBannerShown = _a[1];
    var _b = __read(useState(null), 2), bannerInfo = _b[0], setBannerInfo = _b[1];
    var _c = __read(useState(), 2), bannerType = _c[0], setBannerType = _c[1];
    var messageListener = useCallback(function (_a) {
        var dataFromMessage = _a.data;
        if (!dataFromMessage || isBannerShown) {
            return;
        }
        var data = null;
        try {
            data = typeof dataFromMessage === 'string' ? JSON.parse(dataFromMessage) : dataFromMessage;
        }
        catch (_) {
            data = dataFromMessage;
        }
        if (Object.keys(BannerFromIframeToBannerType).includes(data.type)) {
            setBannerType(BannerFromIframeToBannerType[data.type]);
            setBannerInfo(data.branding);
        }
    }, [isBannerShown]);
    useEffect(function () {
        if (!isOutOfPage)
            return;
        window.addEventListener('message', messageListener);
        return function () {
            window.removeEventListener('message', messageListener);
        };
    }, [isOutOfPage, messageListener]);
    if (!bannerInfo)
        return null;
    var WrapperByType = bannerType ? outOfPageWrappersMap[bannerType] : null;
    if (!WrapperByType)
        return null;
    return React.createElement(WrapperByType, { bannerInfo: bannerInfo, setBannerShown: setBannerShown.on, className: className });
};

/*! js-cookie v3.0.5 | MIT */
/* eslint-disable no-var */
function assign (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      target[key] = source[key];
    }
  }
  return target
}
/* eslint-enable no-var */

/* eslint-disable no-var */
var defaultConverter = {
  read: function (value) {
    if (value[0] === '"') {
      value = value.slice(1, -1);
    }
    return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
  },
  write: function (value) {
    return encodeURIComponent(value).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    )
  }
};
/* eslint-enable no-var */

/* eslint-disable no-var */

function init (converter, defaultAttributes) {
  function set (name, value, attributes) {
    if (typeof document === 'undefined') {
      return
    }

    attributes = assign({}, defaultAttributes, attributes);

    if (typeof attributes.expires === 'number') {
      attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
    }
    if (attributes.expires) {
      attributes.expires = attributes.expires.toUTCString();
    }

    name = encodeURIComponent(name)
      .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
      .replace(/[()]/g, escape);

    var stringifiedAttributes = '';
    for (var attributeName in attributes) {
      if (!attributes[attributeName]) {
        continue
      }

      stringifiedAttributes += '; ' + attributeName;

      if (attributes[attributeName] === true) {
        continue
      }

      // Considers RFC 6265 section 5.2:
      // ...
      // 3.  If the remaining unparsed-attributes contains a %x3B (";")
      //     character:
      // Consume the characters of the unparsed-attributes up to,
      // not including, the first %x3B (";") character.
      // ...
      stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
    }

    return (document.cookie =
      name + '=' + converter.write(value, name) + stringifiedAttributes)
  }

  function get (name) {
    if (typeof document === 'undefined' || (arguments.length && !name)) {
      return
    }

    // To prevent the for loop in the first place assign an empty array
    // in case there are no cookies at all.
    var cookies = document.cookie ? document.cookie.split('; ') : [];
    var jar = {};
    for (var i = 0; i < cookies.length; i++) {
      var parts = cookies[i].split('=');
      var value = parts.slice(1).join('=');

      try {
        var found = decodeURIComponent(parts[0]);
        jar[found] = converter.read(value, found);

        if (name === found) {
          break
        }
      } catch (e) {}
    }

    return name ? jar[name] : jar
  }

  return Object.create(
    {
      set,
      get,
      remove: function (name, attributes) {
        set(
          name,
          '',
          assign({}, attributes, {
            expires: -1
          })
        );
      },
      withAttributes: function (attributes) {
        return init(this.converter, assign({}, this.attributes, attributes))
      },
      withConverter: function (converter) {
        return init(assign({}, this.converter, converter), this.attributes)
      }
    },
    {
      attributes: { value: Object.freeze(defaultAttributes) },
      converter: { value: Object.freeze(converter) }
    }
  )
}

var api = init(defaultConverter, { path: '/' });

/**
 * Parse cookie
 * @param {string} value - cookie string
 * @param {string} separator
 * @returns {Object}
 */
const parseCookie = (value, separator) => {
    if (!value) {
        return {};
    }
    const decodedValue = decodeURIComponent(value);
    return decodedValue.split(separator).reduce((acc, cur) => {
        const [key, value] = cur.split("=");
        acc[key] = /^\s/.test(value) || !value ? undefined : value;
        return acc;
    }, {});
};
const parseUTMCookie = (value) => parseCookie(value, "|");

var decorateParams = function (banner, abName) {
    var _a, _b, _c;
    if (!(banner === null || banner === void 0 ? void 0 : banner.params)) {
        return {};
    }
    var tag = banner.tag, params = banner.params;
    var mainParams = Object.entries(params).reduce(function (acc, _a) {
        var _b, _c;
        var _d = __read(_a, 2), key = _d[0], value = _d[1];
        if (!value && value !== false)
            return acc;
        var normalizedValue = Array.isArray(value) ? value.join(':') : value.toString();
        if (!normalizedValue)
            return acc;
        var tagFromAdFoxDictionary = AD_FOX_DICTIONARY[key];
        if (!tagFromAdFoxDictionary) {
            return __assign(__assign({}, acc), (_b = {}, _b[key] = normalizedValue, _b));
        }
        return __assign(__assign({}, acc), (_c = {}, _c[tagFromAdFoxDictionary] = normalizedValue, _c));
    }, {});
    var utmzCookie = api.get('__utmz');
    var _d = parseUTMCookie(utmzCookie !== null && utmzCookie !== void 0 ? utmzCookie : ''), utmcmd = _d.utmcmd, utmcsr = _d.utmcsr;
    var abCookie = abName && api.get(abName);
    return __assign(__assign(__assign(__assign({ slotTag: tag }, mainParams), (utmcsr && (_a = {}, _a[AD_FOX_DICTIONARY.utmcsr] = utmcsr, _a))), (utmcmd && (_b = {}, _b[AD_FOX_DICTIONARY.utmcmd] = utmcmd, _b))), (abCookie && (_c = {}, _c[AD_FOX_DICTIONARY.ab_test] = "".concat(abName, "_").concat(abCookie), _c)));
};

const LEVELS = {
    DEBUG: "debug",
    INFO: "info",
    WARNING: "warn",
    ERROR: "error",
};
const LEVEL_LABELS = {
    [LEVELS.DEBUG]: "debug",
    [LEVELS.INFO]: "info",
    [LEVELS.WARNING]: "warn",
    [LEVELS.ERROR]: "error",
};
const LEVEL_COLORS = {
    [LEVELS.DEBUG]: "#00CCFF",
    [LEVELS.INFO]: "#6600CC",
    [LEVELS.WARNING]: "#FF9933",
    [LEVELS.ERROR]: "#CC3333",
};
const DEFAULT_CONTEXT = "app";
/**
 * Fast and simple dev logger
 * @description Logs visible only in development environment
 * @class
 * @example
 * ```ts
 * const logger = new Logger('test')
 * logger.debug('Test message', { a: 'b', b: 'a' })
 * ```
 */
class Logger {
    context;
    /**
     * @param context Logger context
     */
    constructor(context = DEFAULT_CONTEXT) {
        this.context = context;
    }
    /**
     * Print log message to console
     * @param level Log level
     * @param message Text message
     * @param [meta] Additional data
     */
    log(level, message, meta) {
        if (process.env.NODE_ENV === "development") {
            const label = this.context;
            const color = LEVEL_COLORS[level];
            const labelStyle = `font-weight: bold; color: ${color}`;
            const ctxStyle = "font-weight: bold; color: #CC00FF";
            const msgStyle = "font-weight: normal;";
            const time = new Date().toLocaleTimeString();
            if (typeof message === "object") {
                console.log(`%c${time} %c[${LEVEL_LABELS[level]}] %c${label} `, msgStyle, labelStyle, ctxStyle, message);
            }
            else if (typeof meta !== "undefined") {
                console.groupCollapsed(`%c${time} %c[${LEVEL_LABELS[level]}] %c${label} %c${message}`, msgStyle, labelStyle, ctxStyle, msgStyle);
                console.log(meta);
                console.groupEnd();
            }
            else {
                console.log(`%c${time} %c[${LEVEL_LABELS[level]}] %c${label} %c${message}`, msgStyle, labelStyle, ctxStyle, msgStyle);
            }
        }
    }
    /**
     * Print log with debug level
     * @param message Text message
     * @param meta Additional data
     */
    debug(message, meta) {
        this.log(LEVELS.DEBUG, message, meta);
    }
    /**
     * Print log with info level
     * @param message Text message
     * @param meta Additional data
     */
    info(message, meta) {
        this.log(LEVELS.INFO, message, meta);
    }
    /**
     * Print log with warning level
     * @param message Text message
     * @param meta Additional data
     */
    warn(message, meta) {
        this.log(LEVELS.WARNING, message, meta);
    }
    /**
     * Print log with error level
     * @param message Text message
     * @param meta Additional data
     */
    error(message, meta) {
        this.log(LEVELS.ERROR, message, meta);
    }
}

const defaultOptions = {
    debug: false,
    delay: 500,
    onError: () => { },
};
/**
 * Client side tasks queue
 * @class
 * @example
 * ```ts
 * const queue = new Queue()
 * queue.push(() => {})
 * ```
 */
class Queue {
    tasks;
    options;
    running = false;
    logger;
    /**
     * @param options Options
     */
    constructor(options) {
        this.options = { ...defaultOptions, ...options };
        this.tasks = [];
        this.logger = new Logger("queue");
        this.log(`Starting process tasks after ${this.options.delay}ms`);
        this.run();
    }
    /**
     * Add task in queue
     * @param task Task function
     */
    push(task) {
        this.pushTask(task);
    }
    log(message, meta) {
        if (!this.options.debug)
            return;
        this.logger.debug(message, meta);
    }
    pushTask(task) {
        this.tasks.push(task);
        this.log("Task registered. Waiting for CPU is idle", task);
        if (this.running) {
            this.requestPopInIdle();
        }
    }
    execute = async () => {
        const task = this.tasks.shift();
        if (!task) {
            this.log("Queue is empty. Waiting for a new task");
            return;
        }
        try {
            this.log("Task found. Run executor", task);
            await task();
            // this.log('Run executor successful')
        }
        catch (error) {
            this.log("Run executor failed", error);
            if (this.options.onError) {
                // @ts-ignore
                this.options.onError(error, task);
            }
        }
    };
    requestPopInIdle() {
        (window.requestIdleCallback || window.setTimeout)(this.execute);
    }
    run() {
        if (typeof window !== "undefined") {
            const performance = window.performance.getEntriesByType("navigation")[0];
            if (performance && performance.loadEventEnd > 0) {
                this.runTasksExecutor();
            }
            else {
                window.addEventListener("load", () => setTimeout(this.runTasksExecutor.bind(this), this.options.delay));
            }
        }
    }
    runTasksExecutor() {
        this.tasks.forEach(() => this.requestPopInIdle());
        this.running = true;
    }
}

var queue = new Queue({ debug: false });

var _a;
var BANNER_TYPES_WITH_PLACEHOLDERS = [BANNER_TYPES.TGBM_7, BANNER_TYPES.SIDE, BANNER_TYPES.TOP];
var DEFAULT_HAS_PLACEHOLDER = (_a = {},
    _a[BANNER_TYPES.TGBM_7] = true,
    _a[BANNER_TYPES.SIDE] = true,
    _a[BANNER_TYPES.TOP] = false,
    _a);

var loadJs = function (src) {
    return new Promise(function (resolve, reject) {
        var tag = document.createElement('script');
        tag.type = 'text/javascript';
        tag.async = false;
        tag.addEventListener('load', resolve);
        tag.addEventListener('error', reject);
        tag.src = src;
        document.body.appendChild(tag);
    });
};

function promiseOnce(fn) {
    var promise = null;
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!promise) {
            promise = Promise.resolve(fn.apply(void 0, __spreadArray([], __read(args), false)));
        }
        return promise;
    };
}

var loadYandexAdsContextOnce = promiseOnce(function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, loadJs('https://yandex.ru/ads/system/context.js')];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); });
var initBanner = function (_a) {
    var lazy = _a.lazy, containerId = _a.containerId, decoratedParams = _a.decoratedParams, onError = _a.onError, onLoad = _a.onLoad, onRender = _a.onRender, onStub = _a.onStub;
    window.yaContextCb = window.yaContextCb || [];
    window.yaContextCb.push(function () {
        // @ts-expect-error Cannot find name Ya
        Ya.adfoxCode.create({
            lazyLoad: lazy,
            ownerId: COMPANY_ID_YANDEX,
            containerId: containerId,
            params: decoratedParams,
            onError: onError,
            onLoad: onLoad,
            onRender: onRender,
            onStub: onStub
        });
    });
};

var modules_efc4e723 = {"container":"_1nfdj7e","container_video":"_1ra18f1","placeholder":"_ah2yms","placeholder_side":"_1ispwki","placeholder_tgbm7":"_1e80uc2","placeholder_top":"_andq2c","placeholder_video":"_10hlof7"};
import "./assets/index.esm-691f1f67.css";

// Yandex Banner
var AdFox$1 = memo(function (_a) {
    var _b, _c;
    var banner = _a.banner, bannerClassName = _a.bannerClassName, placeholderClassName = _a.placeholderClassName, _d = _a.lazy, lazy = _d === void 0 ? false : _d, abName = _a.abName, type = _a.type, _e = _a.hasPlaceholder, hasPlaceholder = _e === void 0 ? DEFAULT_HAS_PLACEHOLDER[type || ''] : _e, onError = _a.onError, onRender = _a.onRender, onClick = _a.onClick, rest = __rest(_a, ["banner", "bannerClassName", "placeholderClassName", "lazy", "abName", "type", "hasPlaceholder", "onError", "onRender", "onClick"]);
    var _f = __read(useState(), 2), containerId = _f[0], setContainerId = _f[1];
    var _g = __read(useState(), 2), isBannerLoaded = _g[0], setBannerLoaded = _g[1];
    var _h = __read(useBoolean(false), 2), isError = _h[0], setError = _h[1];
    var _j = __read(useBoolean(false), 2), isLoadedByYandex = _j[0], setLoadedByYandex = _j[1];
    var _k = __read(useBoolean(false), 2), isBannerRendered = _k[0], setBannerRenderStatus = _k[1];
    var decoratedParams = (banner === null || banner === void 0 ? void 0 : banner.params) ? decorateParams(banner, abName) : {};
    var prevBanner = usePrevious(banner);
    useEffect(function () {
        if (_isEqual(banner, prevBanner))
            return;
        var id = nanoid();
        setContainerId(id);
        setBannerLoaded(false);
        setError.off();
        setLoadedByYandex.off();
        setBannerRenderStatus.off();
    }, [banner, prevBanner, setContainerId, setBannerLoaded, setError, setLoadedByYandex, setBannerRenderStatus]);
    var handleError = function (error) {
        setError.on();
        onError(JSON.stringify(error));
    };
    var handleRender = function () {
        setBannerRenderStatus.on();
        onRender === null || onRender === void 0 ? void 0 : onRender();
    };
    var handleLoad = function () {
        setLoadedByYandex.on();
    };
    var handleStub = function () {
        handleError({ type: 'stub', message: "\u0412 adfox \u043D\u0435\u0442 \u043F\u043E\u0434\u0445\u043E\u0434\u044F\u0449\u0435\u0433\u043E \u0431\u0430\u043D\u043D\u0435\u0440\u0430" });
    };
    useEffect(function () {
        if (!containerId || isBannerLoaded || !banner)
            return;
        setBannerLoaded(true);
        queue.push(function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, loadYandexAdsContextOnce().then(setError.off)["catch"](setError.on)];
                    case 1:
                        _a.sent();
                        initBanner({
                            lazy: lazy,
                            containerId: containerId,
                            decoratedParams: decoratedParams,
                            onError: handleError,
                            onLoad: handleLoad,
                            onRender: handleRender,
                            onStub: handleStub
                        });
                        return [2 /*return*/];
                }
            });
        }); });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [containerId, isBannerLoaded, banner, handleError, handleLoad, handleStub]);
    var withPlaceholder = hasPlaceholder && BANNER_TYPES_WITH_PLACEHOLDERS.includes(((banner === null || banner === void 0 ? void 0 : banner.bannerType) || type));
    return (React.createElement("div", __assign({}, rest),
        React.createElement("div", { onClick: onClick },
            React.createElement("div", { id: containerId, key: containerId, className: cn(modules_efc4e723.container, (_b = {},
                    _b[modules_efc4e723.container_video] = (banner === null || banner === void 0 ? void 0 : banner.isVideo) && isLoadedByYandex && !isBannerRendered,
                    _b), bannerClassName) })),
        withPlaceholder && !isLoadedByYandex && !isError && (React.createElement(Skeleton.Button, { block: true, className: cn(modules_efc4e723.placeholder, 'adfox_placeholder', modules_efc4e723["placeholder_".concat((banner === null || banner === void 0 ? void 0 : banner.bannerType) || type)], (_c = {},
                _c[modules_efc4e723.placeholder_video] = banner === null || banner === void 0 ? void 0 : banner.isVideo,
                _c), placeholderClassName) }))));
});
AdFox$1.displayName = 'AdFox';

var normalizeBannerFromService = function (banner) {
    var _a;
    var type = (_a = Object.entries(BANNER_TYPES).find(function (_a) {
        var _b = __read(_a, 2); _b[0]; var value = _b[1];
        return value.toLowerCase() === banner.bannerType.toLowerCase();
    })) === null || _a === void 0 ? void 0 : _a[1];
    return __assign(__assign({}, banner), { bannerType: type !== null && type !== void 0 ? type : banner.bannerType });
};

var Banner = memo(function (_a) {
    var className = _a.className, type = _a.type, bannersFromProps = _a.banner, onError = _a.onError, rest = __rest(_a, ["className", "type", "banner", "onError"]);
    var banners = Array.isArray(bannersFromProps) ? bannersFromProps : [bannersFromProps];
    var wrapper = useOutOfPageBanner(type === BANNER_TYPES.OUT_OF_PAGE, className);
    var _b = __read(useState(0), 2), bannerNumber = _b[0], setBannerNumber = _b[1];
    var banner = bannerNumber > -1 ? banners[bannerNumber] : null;
    var handleError = useCallback(function (message) {
        console.error(message);
        setBannerNumber(function (prev) { return prev + 1; });
    }, []);
    if (bannerNumber === -1) {
        onError && onError(bannersFromProps);
        return null;
    }
    if (!banner) {
        onError && onError(bannersFromProps);
        return null;
    }
    var isValidBanner = banner.source === YANDEX;
    if (!isValidBanner) {
        handleError("Not valid banner ".concat(JSON.stringify(banner)));
        return null;
    }
    var normalizedBanner = normalizeBannerFromService(banner);
    return (React.createElement(React.Fragment, null,
        React.createElement(AdFox$1, __assign({ banner: normalizedBanner, className: className, type: type, onError: handleError }, rest)),
        wrapper));
});
Banner.displayName = 'Banner';

var AmpBanner = function (_a) {
    var banner = _a.banner, abName = _a.abName, layout = _a.layout, height = _a.height, width = _a.width, className = _a.className;
    return (
    // @ts-expect-error Property amp-ad does not exist on type JSX.IntrinsicElements
    React.createElement("amp-ad", { height: height, width: width, type: "adfox", "class": className, layout: layout, "data-owner-id": COMPANY_ID_YANDEX, "data-adfox-params": "".concat(JSON.stringify(decorateParams(banner, abName))) }));
};

export { AmpBanner, BANNER_TYPES, Banner };
